import { render } from "./RaTerms.vue?vue&type=template&id=5c620755"
import script from "./RaTerms.vue?vue&type=script&lang=js"
export * from "./RaTerms.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__